<template>
  <div class="i-classroom-multi-picker">
    <div class="field-label">
      {{ label }}
    </div>
    <multiselect
      v-model="selectedClassroom"
      label="name"
      trackBy="id"
      :options="classrooms"
      :multiple="false"
      :placeholder="placeholder"
      :disabled="disabled"
      @search-change="onSearch"
      @select="onSelect"
      @remove="onRemove"
    >
      <template slot="option" slot-scope="{ option }">
        <div>{{ option.name }}</div>
        <div v-if="showInfo" class="i-user-picker-email">{{ option.email }}</div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import {listClassrooms} from "@/services/api/google/recovery/classroom/classroom";
import {defaultPagination} from "@/services/pagination";

export default {
  name: 'IClassroomPicker',
  components: {Multiselect},
  props: {
    value: {},
    label: {
      type: String,
      default: 'Classroom'
    },
    placeholder: {
      type: String,
      default: 'Search for classrooms here'
    },
    filter: {
      type: Object,
      default: {
        "statuses": [
          1, 2, 4
        ]
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showInfo: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selectedClassroom: null,
      classrooms: []
    }
  },

  methods: {
    onSearch(searchTerm) {
      this.classrooms = [];
      this.loadClassrooms(searchTerm)
    },
    loadClassrooms(search = null) {
      listClassrooms({
        pagination: {
          ...defaultPagination(),
          pageSize: 300,
          sortBy: 'name',
          sortDescending: false
        },
        search,
        filter: this.filter
      })
        .then(({result, pagination}) => {
          this.classrooms = result;
        })
    },
    onSelect(data) {
      this.$emit('input', data)
    },
    onRemove(data) {
      this.$emit('input', null)
    }
  },

  created() {
    this.selectedClassroom = this.value;

    this.loadClassrooms();
  },
}
</script>

<style lang="scss">
@import "IUserMultiPicker";
</style>
